import { Redirect, Route, Switch } from "react-router-dom";
import { IonReactRouter } from "@ionic/react-router";
import { MainHeader } from "components/Header/MainHeader";
import { LoginSignUp } from "pages/login/Login";
import { useRecoilValue } from "recoil";
import { tokenState } from "recoil/tokenAtom";
import { IonRouterOutlet } from "@ionic/react";
import { LoginHome } from "pages/login/LoginHome";
import { LoginSignIn } from "pages/login/LoginSignIn";
import { loadingAtom } from "recoil/loadingAtom";
import { LoadingScreen } from "components/loading/LoadingScreen";
import { RecuperarContraseña } from "pages/recuperar-contraseña/RecuperarContraseña";
import { useEffect, useState } from "react";

export const AppRoutes = () => {
  const token = useRecoilValue(tokenState);
  const loadingScreen = useRecoilValue(loadingAtom);
  const isOpened = localStorage.getItem("begin");

  return (
    <IonReactRouter>
      {token?.jwtToken ? (
        loadingScreen ? (
          <LoadingScreen
            title="Creando tu perfil..."
            subTitle="Espera unos segundos"
          />
        ) : (
          <MainHeader />
        )
      ) : (
        <IonRouterOutlet id="main">
          <Route exact path="/login/home" component={LoginHome} />
          <Route exact path="/login/signin" component={LoginSignIn} />
          <Route exact path="/login/signup" component={LoginSignUp} />
          <Route
            exact
            path="/recuperar-contraseña"
            component={RecuperarContraseña}
          />

          {/* fallback si entra a / o a cualquier otra ruta sin estar logueado */}
          <Redirect
            to={isOpened === "true" ? "/login/signin" : "/login/home"}
          />
        </IonRouterOutlet>
      )}
    </IonReactRouter>
  );
};
